/* 形状-圆形滤镜 */
import type { Canvas } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';
import ShapeFilter from './shape';

// √2
const SQRT2 = 1.414;

export default class ShapeCircleFilter extends ShapeFilter {
    public type = AnimFilters.SHAPE_CIRCLE;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super(options);
    }

    protected drawShape(canvas: Canvas): void {
        const { width, height, bounds } = canvas;
        const { x, y } = bounds;
        const process = this.direction === PresetSubtype.EleCenter ? 1 - this.rate : this.rate;
        canvas.beginPath();
        const centerX = x + (width / 2);
        const centerY = y + (height / 2);
        // 长短轴为矩形区域宽高的 √2 / 2 恰好盖住矩形区域
        const radiusX = (SQRT2 * width) / 2 * process;
        const radiusY = (SQRT2 * height) / 2 * process;
        canvas.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, Math.PI * 2);
        canvas.fill();
    }
}
